import { createFileRoute } from '@tanstack/react-router';
import { PolicyPage } from '@/features/metric-hub/policy/PolicyPage';

/**
 * Company-wide Metric Hub Usage Policy — interactive long-form page with a
 * branded, Head-of-Data-signed PDF download. Visible to every authenticated
 * user (lives in the Metric Hub "Learn" sidebar group).
 */
export const Route = createFileRoute('/_authed/metric-hub/policy')({
  component: PolicyPage,
});
